import { Target, Layers, TrendingDown } from "lucide-react";

const failures = [
  {
    icon: Target,
    title: "Wrong match types for the budget",
    body:
      "Broad match on a $20/day budget is a money fire. Phrase match too early and you starve the algorithm of signal. Most beginners pick the wrong one.",
  },
  {
    icon: Layers,
    title: "Wrong number of ad groups",
    body:
      "Splitting a $30/day budget across 6 ad groups means none of them ever get enough conversions for Google to learn. One tight group beats six fragmented ones.",
  },
  {
    icon: TrendingDown,
    title: "Wrong bidding strategy",
    body:
      "Target CPA on a brand-new account with zero conversion history doesn't optimize, it stalls. Manual CPC isn't old-school — it's correct at the start.",
  },
];

const McpPainSection = () => {
  return (
    <section className="py-20 px-4 bg-background border-b border-border">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Built for founders who can't justify a PPC agency
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Agencies cost $1,000+ a month and take weeks to launch. The Google
            Ads UI is a 14-screen wizard you don't have time to learn. Most
            small-budget accounts don't fail because the ads are bad — they
            fail because the{" "}
            <span className="text-foreground font-semibold">structure</span> is
            wrong for the budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {failures.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-lg border border-border bg-card p-6 text-card-foreground"
            >
              <div className="h-10 w-10 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-4">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-semibold text-lg mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground">{body}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-center text-muted-foreground max-w-2xl mx-auto">
          Upfixe MCP picks the right structure for your daily budget,{" "}
          <span className="text-foreground font-semibold">before</span> you spend
          a cent.
        </p>
      </div>
    </section>
  );
};

export default McpPainSection;
